export default "__VITE_ASSET__BSESBgK9__"